module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point02_02_miyakoblue-4505bc7bd7134c762842c753b7ec0473.jpg";